import { render, staticRenderFns } from "./framework-login.vue?vue&type=template&id=4f369df2&"
import script from "./framework-login.vue?vue&type=script&lang=js&"
export * from "./framework-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports